module.exports = __webpack_public_path__ + "static/power-img1-1@2x-60fddc37e361f8cd155c87d632d092d3.png";